// Accident Details Component
// Displays accident type, date, and lawyer status

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Car } from 'lucide-react';

const AccidentDetails = ({ intake }) => {
  return (
    <Card className="border-slate-200" data-testid="accident-details-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <Car className="w-5 h-5 text-slate-600" />
          Accident Details
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Type</p>
            <p className="text-slate-900 font-medium capitalize">{intake.accident_type}</p>
          </div>
          <div>
            <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Date</p>
            <p className="text-slate-900 font-medium">{intake.accident_date}</p>
          </div>
        </div>
        <Separator />
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Has Existing Lawyer</p>
          <p className="text-slate-900 font-medium">{intake.has_lawyer ? 'Yes' : 'No'}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default AccidentDetails;
